"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SpinPackageContext = exports.DomainEntries = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("./index"));
var _classnames = _interopRequireDefault(require("classnames"));
var _collapsible = _interopRequireDefault(require("@ux/collapsible"));
var _hooks = require("./hooks");
var _utils = require("@site/utils");
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
var _reactMintl = require("@godaddy/react-mintl");
var _uxUtils = require("@site/ux-utils");
var _SpinAddToCartButton = _interopRequireDefault(require("./SpinAddToCartButton"));
var _CollapsibleContent = _interopRequireDefault(require("./CollapsibleContent"));
var _SpinsAi = _interopRequireDefault(require("../SpinsAi"));
var _useCardSpins = require("../hooks/useCardSpins");
var _utilities = require("../SpinsGrid/utilities");
var _RecommendedSpinsSlider = _interopRequireDefault(require("../RecommendedSpinsSlider"));
var _useApiData = require("../hooks/useApiData");
var _RequestApiType = _interopRequireDefault(require("../constants/RequestApiType"));
var _SpinCardRecommendations = _interopRequireDefault(require("../SpinCard/SpinCardRecommendations"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const SpinPackageContext = exports.SpinPackageContext = /*#__PURE__*/_react.default.createContext(null);
const DomainEntries = ({
  spinResultsWrapRef,
  language = {},
  recommendedDomains = [],
  dataCy,
  dataEid,
  strongSeparatorLines = false,
  showDetailView = false,
  options = {},
  ctaProps = {},
  AddToCartButton,
  CustomCartStateBadge,
  PriceBlock,
  CelebrateDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
  PremiumDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
  SpinInCartExpandedComponent = () => /*#__PURE__*/_react.default.createElement("div", null),
  removeAdditionalWrappers = false,
  enableDynamicFontScaling = false,
  eidPrefix,
  cartContents,
  dbsPrice,
  gridNumOfColumns = 3,
  apm,
  moreSpinsRecommendedDomains = []
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const {
    privateLabelId,
    domainEntries = {},
    exactMatchDomain = {},
    enableHover,
    scrollSelectedSpinToTop,
    hideDetailedViewExactMatch,
    showPriceSavings,
    displayPercentagePrice = false,
    styleOverrides: {
      pricingStyleOverrides = {}
    } = {},
    dueTodayMessage = '',
    isListPricePriority = false,
    isPriceLinePriority = false,
    overrideCurrentPriceToZero = false,
    term = 0,
    hideListPrice = false,
    showFreeIndicator = false,
    stickyHeaderSelector = null,
    isPromoForNewCustomer = false,
    isSpinExpandable,
    apiKey,
    resellerBaseUrl,
    aiSearchInSpins = {},
    showCardSpins = false,
    showMoreLikeThisOption = false,
    showMoreLikeThisNumberOfCards = 4,
    merchRecommendSpinsOptions = {},
    autoAddDopOptions
  } = options;
  const {
    spinsAiPosition,
    handleAiDomainSearchClick,
    spinsAiTextId,
    spinsAiNumberOfCards,
    spinsAiButtonClassName,
    spinsAiButtonIconColor
  } = aiSearchInSpins;
  const {
    merchRecommendSpinsPosition
  } = merchRecommendSpinsOptions;
  const {
    spinsData,
    requestStatus
  } = (0, _useApiData.useApiData)((merchRecommendSpinsPosition || merchRecommendSpinsPosition === 0) && _RequestApiType.default.MERCH_RECOMMEND_API, {
    ...options
  }, apm);
  const {
    isTwoCardLayout = false,
    secondCardDomain
  } = domainEntries;
  recommendedDomains = [...recommendedDomains, ...moreSpinsRecommendedDomains];
  const filteredDomains = recommendedDomains.filter(spin => !(isTwoCardLayout && spin.Fqdn === secondCardDomain) && spin.Fqdn !== exactMatchDomain.Fqdn);
  const stickyHeaderHeight = stickyHeaderSelector ? document.querySelector(stickyHeaderSelector)?.offsetHeight : document.getElementsByTagName('header')[0]?.offsetHeight;
  const {
    scrollSpinToTop,
    spinCollapsibleRefs
  } = (0, _hooks.useScrollSelectedSpinToTop)(stickyHeaderHeight);
  const initialExpandedSpins = filteredDomains.map(domain => Array.from(cartContents || []).some(cartItem => cartItem.Fqdn === domain.Fqdn));
  const [clickedStates, setClickedStates] = (0, _react.useState)(isSpinExpandable ? initialExpandedSpins : []);
  const [showMoreLikeThisDomainsButtonStates, setShowMoreLikeThisDomainsButtonStates] = (0, _react.useState)(isSpinExpandable ? initialExpandedSpins : []);
  const [expandedSpinsNotAvailable, setExpandedSpinsAvailable] = (0, _react.useState)([]);
  const [selectedSpinIndex, setSelectedSpinIndex] = (0, _react.useState)(-1);
  const [showAiDomains, setShowAiDomains] = (0, _react.useState)(false);
  const handleClickedStates = index => {
    if (enableHover || isSpinExpandable) {
      const newClickedStates = [...clickedStates];
      if (selectedSpinIndex !== -1 && selectedSpinIndex !== index) {
        /* this gets bypassed if user clicks on the selected expanded slat to close it.
        we take care of handling that case after this if logic */
        newClickedStates[selectedSpinIndex] = false;
      }
      if (newClickedStates[index]) {
        setShowMoreLikeThisDomainsButtonStates(initialExpandedSpins);
      }
      newClickedStates[index] = !newClickedStates[index];
      setClickedStates(newClickedStates);
    }
  };
  const onExpandedSpinDataNotAvailable = index => {
    const newExpandedSpinsNotAvailable = [...expandedSpinsNotAvailable];
    newExpandedSpinsNotAvailable[index] = true;
    setExpandedSpinsAvailable(newExpandedSpinsNotAvailable);
  };
  const getIsExpandedContentVisible = index => {
    const isExpandableContentAvailable = isSpinExpandable && clickedStates[index] && !expandedSpinsNotAvailable[index];
    return isExpandableContentAvailable && !isMobile;
  };
  const handleShowMoreLikeThisClick = (index, e, openButton) => {
    const showMoreLikeThisDomains = [...showMoreLikeThisDomainsButtonStates];
    showMoreLikeThisDomains[index] = !showMoreLikeThisDomains[index];
    setShowMoreLikeThisDomainsButtonStates(showMoreLikeThisDomains);
    if (openButton) {
      e.stopPropagation();
    }
  };
  const handleCollapsibleClick = (domain, index, isOpen) => {
    const getEid = () => {
      const eventType = isOpen ? 'SpinsExpand' : 'SpinsCollapse';
      const spinType = domain.IsAd ? 'AdSpins' : 'Spins';
      return _EidCodes.default.Domain[eventType][spinType];
    };
    setSelectedSpinIndex(isOpen ? index : -1);
    handleClickedStates(index);
    scrollSelectedSpinToTop && !isSpinExpandable && scrollSpinToTop(isOpen ? index : -1);
    (0, _utils.logEvent)({
      eid: getEid(),
      type: 'click',
      properties: {
        position: index + 1,
        domain: domain.Fqdn
      }
    });
  };
  const isSelectedSpinContentVisible = index => !scrollSelectedSpinToTop || hideDetailedViewExactMatch || scrollSelectedSpinToTop && selectedSpinIndex !== index || isSpinExpandable;
  const spinPriceOption = {
    displayPercentagePrice,
    showPriceSavings,
    classNames: {
      ...pricingStyleOverrides
    },
    dueTodayMessage,
    isListPricePriority,
    isPriceLinePriority,
    overrideCurrentPriceToZero,
    term,
    hideListPrice,
    showFreeIndicator,
    isPromoForNewCustomer
  };
  const populatedSpins = (domain, index, openButton, isDomainInCart) => {
    const isPremiumSpin = (0, _utils.isAftermarketPremium)(domain) || (0, _utils.isRegPremium)(domain) || (0, _utils.isAuction)(domain);
    const detailedViewDataCy = isPremiumSpin ? `tight-modern-detailed-view-premium-spin` : 'tight-modern-detailed-view-spin';
    const tooltipButtonAriaLabel = formatMessage({
      id: 'ariaLabelOpenPricingTooltip'
    }, {
      product: domain.Fqdn
    });
    const expandSpinOnAddToCart = () => {
      if (!clickedStates[index]) handleClickedStates(index);
    };
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `spin-${domain.Fqdn}-${index}`
    }, /*#__PURE__*/_react.default.createElement(_index.default, {
      language: language,
      openButton: openButton,
      dataCy: showDetailView ? detailedViewDataCy : dataCy,
      CustomCartStateBadge: CustomCartStateBadge,
      isDomainInCart: isDomainInCart,
      handleShowMoreLikeThisClick: e => handleShowMoreLikeThisClick(index, e, openButton),
      showMoreLikeThisDomains: showMoreLikeThisDomainsButtonStates[index],
      showMoreLikeThisOption: showMoreLikeThisOption,
      dataEid,
      domainEntry: domain,
      product: domain.product,
      options,
      ctaProps,
      customPriceBlock: PriceBlock && /*#__PURE__*/_react.default.createElement(PriceBlock, {
        domain,
        product: domain.product,
        options: {
          ...spinPriceOption,
          tooltipButtonAriaLabel
        },
        enableDynamicFontScaling
      }),
      customAddToCartButton: AddToCartButton && /*#__PURE__*/_react.default.createElement(AddToCartButton, {
        domain,
        product: domain.product,
        dataEid,
        expandSpinOnAddToCart,
        openButton
      }),
      enableDynamicFontScaling,
      eidPrefix: eidPrefix,
      dbsPrice: dbsPrice,
      autoAddDopOptions: autoAddDopOptions
    }), (removeAdditionalWrappers || !showDetailView && index !== filteredDomains.length - 1) && /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "separator-line",
      className: (0, _classnames.default)({
        'bd-t-1': !showAiDomains || index + 1 !== spinsAiPosition,
        'bd-white': !strongSeparatorLines,
        'bd-product-midrange': strongSeparatorLines
      })
    }));
  };
  const SpinsAiComponent = /*#__PURE__*/_react.default.createElement(_SpinsAi.default, {
    showAiDomains: showAiDomains,
    setShowAiDomains: setShowAiDomains,
    handleAiDomainSearchClick: handleAiDomainSearchClick,
    plid: privateLabelId,
    apiKey: apiKey,
    urlOverride: resellerBaseUrl,
    domainToCheck: exactMatchDomain?.Fqdn,
    spinsAiTextId: spinsAiTextId,
    ctaProps: ctaProps,
    options: {
      ...options,
      isListPricePriority: aiSearchInSpins.isListPricePriority
    },
    enableDynamicFontScaling: enableDynamicFontScaling,
    PriceBlock: PriceBlock,
    language: language,
    AddToCartButton: AddToCartButton,
    numberOfCards: spinsAiNumberOfCards,
    containerClasses: !showDetailView && !showAiDomains && 'bd-b-1 bd-gray',
    spinsAiButtonClassName: spinsAiButtonClassName,
    spinsAiButtonIconColor: spinsAiButtonIconColor
  });
  const SpinsCardRecommendationsComponent = /*#__PURE__*/_react.default.createElement(_SpinCardRecommendations.default, {
    plid: privateLabelId,
    apiKey: apiKey,
    urlOverride: resellerBaseUrl,
    ctaProps: ctaProps,
    options: options,
    enableDynamicFontScaling: enableDynamicFontScaling,
    PriceBlock: PriceBlock,
    language: language,
    AddToCartButton: AddToCartButton,
    numberOfCards: showMoreLikeThisNumberOfCards
  });
  const merchRecommendSpinsComponent = /*#__PURE__*/_react.default.createElement(_RecommendedSpinsSlider.default, (0, _extends2.default)({
    options: options,
    PriceBlock: PriceBlock,
    language: language,
    AddToCartButton: AddToCartButton,
    enableDynamicFontScaling: enableDynamicFontScaling,
    ctaProps: ctaProps,
    spinsData: spinsData,
    requestStatus: requestStatus,
    dataEid: _EidCodes.default.MerchRecommend.MerchRecommendAddToCart
  }, merchRecommendSpinsOptions));
  const wrappedSpins = (domain, index) => {
    const isDomainInCart = Array.from(cartContents || []).some(cartItem => cartItem.Fqdn === domain.Fqdn);
    const isExpanded = isSpinExpandable && isDomainInCart && clickedStates[index];
    const expandedContentVisible = getIsExpandedContentVisible(index);
    const prevItemExpandedContentVisible = getIsExpandedContentVisible(index - 1);
    const isSelectedSpinIndex = selectedSpinIndex === index || isExpanded;
    const hideTopBorder = showAiDomains && index === spinsAiPosition || prevItemExpandedContentVisible && !expandedContentVisible && index !== spinsAiPosition;
    const spinsContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      key: `${domain.Fqdn}_${index}`,
      "data-cy": "spins-result",
      "data-testid": "spins-result",
      ref: el => {
        spinCollapsibleRefs.current[index] = el;
      },
      className: (0, _classnames.default)('border-0', {
        gd: (0, _utils.isReseller)(privateLabelId)
      })
    }, isSelectedSpinContentVisible(index) && /*#__PURE__*/_react.default.createElement("div", {
      className: "dpp-results"
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: index === filteredDomains.length - 2 ? spinResultsWrapRef : null,
      className: "spin-results-wrap"
    }, populatedSpins(domain, index, isSelectedSpinIndex, isDomainInCart)))));
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `${domain?.Fqdn}_${index}`
    }, index === spinsAiPosition && SpinsAiComponent, index === merchRecommendSpinsPosition && merchRecommendSpinsComponent, showDetailView || isSpinExpandable && isDomainInCart ? /*#__PURE__*/_react.default.createElement(_collapsible.default, {
      id: `${domain.Fqdn}_${index}`,
      title: spinsContent,
      className: (0, _classnames.default)('detailed-v-panel', {
        clicked: clickedStates[index],
        'spin-expandable': isSpinExpandable,
        'hide-top-border': hideTopBorder,
        'bd-gray bd-t-1': isSpinExpandable && index === 0,
        'border-radius-8 bd-gray bd-a-1': expandedContentVisible,
        'extra-top-space': expandedContentVisible && prevItemExpandedContentVisible
      }),
      onChange: isOpen => handleCollapsibleClick(domain, index, isOpen),
      open: isSelectedSpinIndex,
      icon: /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'none'
        }
      })
    }, isSelectedSpinIndex && /*#__PURE__*/_react.default.createElement(_CollapsibleContent.default, {
      domain: domain,
      CelebrateDetailView: CelebrateDetailView,
      showMoreLikeThisOption: showMoreLikeThisOption,
      SpinsCardRecommendationsComponent: SpinsCardRecommendationsComponent,
      showMoreLikeThisDomains: showMoreLikeThisDomainsButtonStates[index],
      PremiumDetailView: PremiumDetailView,
      SpinInCartExpandedComponent: SpinInCartExpandedComponent,
      isDomainInCart: isDomainInCart,
      isSpinExpandable: isSpinExpandable,
      hideDetailedViewExactMatch: hideDetailedViewExactMatch,
      onExpandedSpinDataNotAvailable: () => onExpandedSpinDataNotAvailable(index)
    })) : spinsContent, merchRecommendSpinsPosition === 'bottom' && index === filteredDomains.length - 1 && merchRecommendSpinsComponent);
  };
  const {
    selectedDetailIndex,
    isRightSpinSelected,
    isLeftSpinSelected,
    onCardSpinClick
  } = (0, _useCardSpins.useCardSpins)({
    gridNumOfColumns,
    selectedSpinIndex,
    setSelectedSpinIndex
  });
  if (showCardSpins) {
    return (0, _utilities.getGridSpinsComponentsArray)({
      filteredDomains,
      gridNumOfColumns,
      selectedSpinIndex,
      selectedDetailIndex,
      isRightSpinSelected,
      isLeftSpinSelected,
      onCardSpinClick,
      isSpinExpandable,
      hideDetailedViewExactMatch,
      ctaProps,
      options,
      cartContents,
      enableDynamicFontScaling,
      PriceBlock,
      language,
      AddToCartButton,
      CelebrateDetailView,
      PremiumDetailView,
      SpinInCartExpandedComponent,
      onExpandedSpinDataNotAvailable,
      CustomCartStateBadge
    });
  }
  const renderSpins = removeAdditionalWrappers ? populatedSpins : wrappedSpins;
  return filteredDomains.map(renderSpins);
};
exports.DomainEntries = DomainEntries;
const ctaPropsPropTypes = {
  ..._SpinAddToCartButton.default.propTypes
};
delete ctaPropsPropTypes.product;
DomainEntries.propTypes = {
  language: _propTypes.default.object.isRequired,
  recommendedDomains: _propTypes.default.array,
  dataCy: _propTypes.default.string,
  dataEid: _propTypes.default.string,
  options: _propTypes.default.object,
  lastEntry: _propTypes.default.bool,
  strongSeparatorLines: _propTypes.default.bool,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  removeAdditionalWrappers: _propTypes.default.bool,
  showDetailView: _propTypes.default.bool,
  CelebrateDetailView: _propTypes.default.func,
  PremiumDetailView: _propTypes.default.node,
  enableDynamicFontScaling: _propTypes.default.bool,
  stickyHeaderSelector: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  ctaProps: _propTypes.default.shape(ctaPropsPropTypes),
  cartContents: _propTypes.default.shape({
    has: _propTypes.default.func
  }),
  SpinInCartExpandedComponent: _propTypes.default.element,
  CustomCartStateBadge: _propTypes.default.element,
  dbsPrice: _propTypes.default.string,
  gridNumOfColumns: _propTypes.default.number,
  apm: _propTypes.default.object
};
var _default = exports.default = DomainEntries;